import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-shipping-policy',
    templateUrl: './shipping-policy.component.html'
})
export class ShippingPolicyComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    	window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/shipping-policy/shipping-policy.component.ts